// @flow
import React from 'react';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import './QuantitySelect.css';
import { fromNullable } from 'fp-ts/lib/Option';
import { InputError } from '../../containers/ProductForm/InputCreator';
import { connect } from 'react-redux';

class QuantitySelect extends React.Component<Props, State> {
  state = {
    quantity: 1
  };

  constructor(props) {
    super(props);
    this.onInputChange = props.onInputChange.bind(this);
  }

  handleChange = quantity => {
    this.onInputChange(quantity);
  };

  render() {
    const { quantity } = this.props;
    const fieldClassName = `pdp-form__field ${
      this.props.quantity.error ? 'pdp-form__field--error' : ''
    }`;

    return (
      <div className={fieldClassName}>
        <label htmlFor='quantity' className='pdp-form__field-label'>
          <span className='pdp-form__field--required'>Card Quantity</span>
        </label>

        <Select
          id='quantity'
          placeholder='Choose an Option...'
          name='quantity'
          searchable={false}
          clearable={false}
          value={quantity.value}
          options={this.props.options}
          onChange={this.handleChange}
        />

        {fromNullable(this.props.quantity.error)
          .map(InputError)
          .getOrElseValue(null)}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  quantity: state.quantity
});

export default connect(mapStateToProps)(QuantitySelect);



// WEBPACK FOOTER //
// ./src/components/QuantitySelect/index.js